export default "__VITE_ASSET__e3580d8d__"